//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
let d=[[[0,"DisplayOnSegments",1,0],[0,"FirstBranchID",1,0],[0,"NextBranchID",1,0],[0,"Prefix",1,0],[0,"ReassignOnSegments",1,0],[0,"SequenceMethod",1,0],[0,"StartValueForLowerCase",1,0],[0,"StartValueForNumbers",1,0],[0,"StartValueForUpperCase",1,0],[0,"Suffix",1,0]],[[["controlPoint"],"SetControlPoint",{},1,0],[["controlPoint"],"SetControlPointFromSegment",{},1,0]],[]];
SPLM.Routing.BranchPathNumberingBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.BranchPathNumberingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.BranchPathNumberingBuilder.Sequence = Object.freeze({
    "Numbers" : "Numbers", "UpperCase" : "UpperCase", "LowerCase" : "LowerCase"});

export default SPLM;